export default (defaultState = 'loading') => ({
	data() {
		return {
			state: defaultState,
		}
	},
	methods: {
		is(state) {
			return this.state === state
		},
		isnt(state) {
			return this.state !== state
		},
		setState(state) {
			this.state = state
		},
	},
})
